import { useState, useCallback, useEffect } from 'react';
import { getInsuranceCompanyListApi } from '@/api/bodyAndPaint';
import { InsuranceCompanyListResponse } from '@/types/api/bodyAndPaint';

export const useGetInsuranceCompanyList = () => {
  const [insuranceCompanyList, setInsuranceCompanyList] =
    useState<InsuranceCompanyListResponse>({} as InsuranceCompanyListResponse);

  const fetchDate = useCallback(async () => {
    try {
      const fetch = await getInsuranceCompanyListApi({});
      if (fetch) {
        setInsuranceCompanyList({
          insurance_companies: fetch?.data.insurance_companies,
        });
      } else {
        setInsuranceCompanyList({} as InsuranceCompanyListResponse);
        throw 'invalid parameter';
      }
    } catch (error) {
      console.error(error);
    }
  }, []);
  useEffect(() => {
    fetchDate();
  }, [fetchDate]);

  return { insuranceCompanyList };
};
